import React, { useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, StyleSheet, View } from 'react-native';
import { AppText } from '@/components/AppText';

const styles = StyleSheet.create({
  badge: {
    backgroundColor: 'red',
    borderRadius: 10,
    paddingHorizontal: 5,
    paddingVertical: 1,
  },
  badgeText: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
  },
});

type Props = {
  val: number,
};

export default function Badge({ val }: Props) : React.ReactNode {
  if (val == 0) {
    return null;
  }
  return (
    <View style={styles.badge}>
      <AppText style={styles.badgeText}>{val}</AppText>
    </View>
  );
};
